import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=5041cfea&scoped=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041cfea",
  null
  
)

export default component.exports